// const.ts
import * as yup from "yup";

export enum UserInputs {
    NAME = "name",
    POSITION = "position",
    CONTACT_NUMBER = "phone",
    EMAIL_ADDRESS = "email",
    PAN = "pan_number",
    USER_TYPE = "userType",
}

export const userInputSchema = yup.object({
    [UserInputs.NAME]: yup.string().required("Please enter name"),
    [UserInputs.POSITION]: yup.string().when(UserInputs.USER_TYPE, {
        is: "Corporate",
        then: (schema) => schema.required("Position is required for Corporate"),
        otherwise: (schema) => schema.optional(),
    }),
    [UserInputs.CONTACT_NUMBER]: yup.string()
        .required("Please enter contact no.")
        .matches(/^[0-9]{10}$/, "Enter valid mobile number - Must be 10 digits"),
    [UserInputs.EMAIL_ADDRESS]: yup.string()
        .email("Enter valid email")
        .required("Please enter email"),
    [UserInputs.PAN]: yup.string().when("$isPanRequired", {
        is: true,
        then: (schema) => schema.required("PAN Card is required when amount > ₹50,000"),
        otherwise: (schema) => schema.notRequired().nullable(),
    }),
    [UserInputs.USER_TYPE]: yup.string()
        .oneOf(["Individual", "Corporate"], "Please select user type")
        .required("Please select if you are Individual or Corporate"),
});

export interface IUserInputs {
    [UserInputs.NAME]: string;
    [UserInputs.POSITION]?: string;
    [UserInputs.CONTACT_NUMBER]: string;
    [UserInputs.EMAIL_ADDRESS]: string;
    [UserInputs.PAN]?: string;
    [UserInputs.USER_TYPE]: "Individual" | "Corporate";
}
